import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=7037208c"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports